module.exports = __webpack_public_path__ + "img/premium-mini.46c53789.png";